import { Component, computed, inject, input } from '@angular/core';
import { OnyxDividerComponent } from '@onyx/angular';
import { RouteHelper } from '../../../../../helpers/route.helper';
import type { RoutePoint } from '../../../../../services/route.service';
import { RouteService } from '../../../../../services/route.service';
import { RoutePointDetailsStatusInProgressComponent } from './route-point-details-status-in-progress/route-point-details-status-in-progress.component';
import { RoutePointDetailsStatusTermComponent } from './route-point-details-status-term/route-point-details-status-term.component';

@Component({
  selector: 'app-route-point-details-status',
  imports: [
    RoutePointDetailsStatusInProgressComponent,
    RoutePointDetailsStatusTermComponent,
    OnyxDividerComponent,
  ],
  templateUrl: './route-point-details-status.component.html',
  styleUrl: './route-point-details-status.component.scss',
  host: {
    '[class]': `context`,
    '[class.tooltip-padding]': `isTooltip()`,
  },
})
export class RoutePointDetailsStatusComponent {
  private readonly routeService = inject(RouteService);

  public readonly point = input.required<RoutePoint>();
  public readonly isTooltip = input(false);

  protected readonly context = this.routeService.context;

  protected isCanceled = computed(() => RouteHelper.isCanceled(this.point()));
}
